<iframe [src]="data.url | safeUrl" width="100%" height="600px"></iframe>